import { render, staticRenderFns } from "./TooltipController.vue?vue&type=template&id=5412b97c&lang=pug&"
import script from "./TooltipController.vue?vue&type=script&lang=js&"
export * from "./TooltipController.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports